import { NeuNavVertical } from '@neutron/react';

import { FC } from 'react';
import { SideNavLabel } from './ValidationUserListSideNavSection';

const ValidationUserListSideNavSection: FC<{
  selectedTab: string;
  changeTab: (tab: string) => void;
}> = ({ selectedTab, changeTab }) => {
  return (
    <NeuNavVertical
      unit="group"
      label="Validation Rounders"
      data-testid="side-nav-validation-list-label"
    >
      <NeuNavVertical
        id="Admin-Side-Nav-Validators"
        active={selectedTab === 'validationRounder'}
        unit="item"
        onClick={() => changeTab('validationRounder')}
      >
        <SideNavLabel>NLR Rounders</SideNavLabel>
      </NeuNavVertical>
      <NeuNavVertical
        id="Admin-Side-Nav-Aidet-Validators"
        active={selectedTab === 'aidetValidationRounder'}
        unit="item"
        onClick={() => changeTab('aidetValidationRounder')}
      >
        <SideNavLabel>AIDET® Rounders</SideNavLabel>
      </NeuNavVertical>
      <NeuNavVertical
        id="Admin-Side-Nav-Bssr-Validators"
        active={selectedTab === 'bssrValidationRounder'}
        unit="item"
        onClick={() => changeTab('bssrValidationRounder')}
      >
        <SideNavLabel>BSSR Rounders</SideNavLabel>
      </NeuNavVertical>
      <NeuNavVertical
        id="Admin-Side-Nav-Safety-Validators"
        active={selectedTab === 'safetyValidationRounder'}
        unit="item"
        onClick={() => changeTab('safetyValidationRounder')}
      >
        <SideNavLabel>Safety Rounders</SideNavLabel>
      </NeuNavVertical>
    </NeuNavVertical>
  );
};

export default ValidationUserListSideNavSection;
